import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M5.25 9C4.0125 9 3 10.0125 3 11.25C3 12.4875 4.0125 13.5 5.25 13.5C6.4875 13.5 7.5 12.4875 7.5 11.25C7.5 10.0125 6.4875 9 5.25 9ZM18.75 9C17.5125 9 16.5 10.0125 16.5 11.25C16.5 12.4875 17.5125 13.5 18.75 13.5C19.9875 13.5 21 12.4875 21 11.25C21 10.0125 19.9875 9 18.75 9ZM12 9C10.7625 9 9.75 10.0125 9.75 11.25C9.75 12.4875 10.7625 13.5 12 13.5C13.2375 13.5 14.25 12.4875 14.25 11.25C14.25 10.0125 13.2375 9 12 9Z' />
        </SvgIcon>
    );
});
